import React from "react"
import PropTypes from "prop-types"
import { Field, reduxForm, propTypes } from "redux-form"
import { injectIntl } from "react-intl"
// ## //
import Box from "@material-ui/core/Box"
import { ButtonSubmit } from "../../component/buttons"
import FieldTextarea from "../../component/forms/FieldTextarea"
import { words } from "../../i18n/lstrings"

const ForgotPasswordForm = ({ onSubmit, submitting, handleSubmit, intl }) => {
  const { formatMessage: format } = intl
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Field
        component={FieldTextarea}
        label={format(words.email)}
        name="email"
        placeholder={format(words.email)}
        type="email"
      />
      <Box className="buttons-right-container">
        <ButtonSubmit disabled={submitting} />
      </Box>
    </form>
  )
}

export const validate = (values, props) => {
  const { formatMessage: format } = props.intl
  const errors = {}
  if (!values.email) {
    errors.email = format(words.required)
  }
  return errors
}

ForgotPasswordForm.propTypes = {
  ...propTypes,
  intl: PropTypes.any.isRequired
}

export default injectIntl(
  reduxForm({
    form: "ForgotPasswordForm",
    validate
  })(ForgotPasswordForm)
)
